/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "370cc3ddf56e5061362670f9ad37b38a44c53af1";
